import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App'

// Capture any unhandled error so the route ErrorBoundary can detect
// chunk-load failures (stale bundle references after redeploy) and auto-reload.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    ;(window as unknown as { __lastError?: Error }).__lastError = e.error ?? new Error(e.message)
  })
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason
    ;(window as unknown as { __lastError?: Error }).__lastError =
      reason instanceof Error ? reason : new Error(String(reason))
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
